import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';

import logo from '../../assets/assessoria/logoSulamericaWhite.svg';
import { ExitIcon } from '../../assets/icons/ExitIcon';
import chevronDown from '../../assets/svgs/chevron_down-icon.svg';
import chevronUp from '../../assets/svgs/chevron_up-icon.svg';
import playIcon from '../../assets/svgs/play-icon.svg';
import { useAuthContext } from '../../contexts/AuthContext';
import { useHeaderContext } from '../../contexts/HeaderContext';
import { apiSensedia } from '../../services/api-sensedia';
import { CustomIcon } from '../widgets/CustomIcon';

type HeaderGlobalProps = {
  hideWLEl?: boolean;
};

export const HeaderGlobal = ({ hideWLEl }: HeaderGlobalProps) => {
  const [iconDropdown, setIconDropdown] = useState('');
  const [dropDownIsOpen, setDropDownIsOpen] = useState(false);

  const { logout } = useAuthContext();
  const { setElementeSize } = useHeaderContext();
  const userSessionRef = useRef(null);

  const { user } = JSON.parse(localStorage.getItem('pdn:user') as string) || {
    user: { name: 'Joaquim Bira' }
  };

  const userName = user.name.split(' ');

  const userAvatar =
    user.name.split(' ').length > 1
      ? user.name.split(' ')[0].charAt(0).toUpperCase() +
        user?.name.split(' ')[1].charAt(0).toUpperCase()
      : user.name.split(' ')[0].charAt(0).toUpperCase() +
          user?.name.split(' ')[0].charAt(0).toUpperCase() || '';

  const isPainel = window.location.href.split('/');

  const handlePreviewButton = async (codigo: string) => {
    const headers = {
      id_site: codigo as string
    };
    const axiosConfig = {
      headers: { ...headers }
    };

    try {
      let response = undefined;
      if (process.env.NODE_ENV === 'development') {
        const url = `${process.env.REACT_APP_WS_WHITELABEL_HOST}/websites/endereco-assinado`;
        response = await axios.post(url, {}, axiosConfig);
      } else {
        response = await apiSensedia.post(
          '/websites/endereco-assinado',
          {},
          {
            headers: { ...headers }
          }
        );
      }

      if (response.data.url) {
        const url = response.data.url;
        window.open(url, '_blank');
      }
      // else {
      //   toast({
      //     description: 'Não foi possível abrir o preview neste momento.',
      //     status: 'error'
      //   });
      // }
    } catch (error) {
      console.log(error);
      // toast({
      //   description: 'Não foi possível abrir o preview neste momento.',
      //   status: 'error'SS
      // });
    }
  };

  useEffect(() => {
    dropDownIsOpen ? setIconDropdown(chevronDown) : setIconDropdown(chevronUp);
  }, [dropDownIsOpen]);

  useEffect(() => {
    if (userSessionRef.current) {
      const width = userSessionRef.current.clientWidth + 80;
      setElementeSize(String(width));
    }
  }, [userSessionRef]);

  return (
    <DropdownMenu.Root
      open={dropDownIsOpen}
      onOpenChange={(isOpen) => setDropDownIsOpen(isOpen)}
    >
      <div className="relative tw-bg-[#001E64] tw-flex tw-justify-between tw-py-[30px] tw-px-[25px]">
        <a href="/corretor">
          <img src={logo} className="tw-w-[123px] tw-h-[32px]" alt="Logo" />
        </a>
        <div className="tw-flex tw-items-center tw-gap-[16px]">
          <button
            style={{
              display: hideWLEl || isPainel.length <= 6 ? 'none' : 'flex'
            }}
            aria-label="preview"
            className={'tw-bg-transparent tw-items-center tw-gap-2'}
            onClick={() => {
              handlePreviewButton(String(location.pathname.split('/')[4]));
            }}
          >
            <CustomIcon src={playIcon} width={35} height={35} />
            <span className="tw-text-white tw-font-normal tw-text-xs">
              Apresentação da página
            </span>
          </button>
          <DropdownMenu.Trigger>
            <div
              className="tw-flex tw-items-center tw-gap-[16px] tw-ml-16"
              ref={userSessionRef}
            >
              <div className="tw-rounded-full tw-w-[40px] tw-h-[40px] tw-bg-[#FF8C00] tw-flex tw-items-center tw-justify-center tw-text-[#FFFFFF] tw-text-[0.875rem] tw-font-semibold">
                {userAvatar}
              </div>
              <div className="tw-text-[#FFFFFF] tw-px-[5px] tw-text-[0.875rem]">
                {user.name}
              </div>
            </div>
          </DropdownMenu.Trigger>
          <button
            onClick={() => setDropDownIsOpen(!dropDownIsOpen)}
            className="tw-text-[#FFFFFF]"
          >
            <DropdownMenu.Trigger>
              <CustomIcon src={iconDropdown} />
            </DropdownMenu.Trigger>
          </button>
        </div>
      </div>
      <DropdownMenu.Content
        align="end"
        sideOffset={0}
        className="tw-w-[217px] tw-bg-[#FFFFFF] tw-rounded-b-[10px] tw-z-30 tw-shadow-2xl tw-cursor-pointer"
        style={{ marginRight: '1rem', marginTop: '42px' }}
      >
        <DropdownMenu.Item className="tw-text-[1.25rem] tw-text-[#011C65] tw-p-5 hover:tw-outline-none">
          {userName.map((name, index) => (
            <div key={index}>
              {index === 0 ? (
                <>
                  Olá, <strong>{name}</strong>
                  <br />
                </>
              ) : index <= 2 ? (
                <strong>{name}</strong>
              ) : null}
            </div>
          ))}
        </DropdownMenu.Item>
        <hr />
        <div className="tw-text-[#828282] tw-p-2.5">
          <p>Minha conta</p>
        </div>

        <DropdownMenu.Item
          onSelect={logout}
          className="tw-text-[1.25rem] tw-text-[#011C65] tw-p-2.5 hover:tw-bg-gray-100 hover:tw-outline-none tw-rounded-b-[10px]"
        >
          <a href={process.env.REACT_APP_PORTAL_URL}>
            <div className="tw-text-[#001E64] tw-flex tw-items-center tw-font-bold tw-gap-[16px]">
              <ExitIcon />
              <span className="">Sair</span>
            </div>
          </a>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
